var exports = {
  "kL": "ChannelSourcePreview.module__container___NElTUm",
  "FS": "ChannelSourcePreview.module__textContainer___NElTUm",
  "S7": "ChannelSourcePreview.module__nameRow___NElTUm",
  "p": "ChannelSourcePreview.module__channelIcon___NElTUm",
  "oo": "ChannelSourcePreview.module__nameButton___NElTUm",
  "fh": "ChannelSourcePreview.module__nameText___NElTUm",
  "W$": "ChannelSourcePreview.module__subtext___NElTUm",
  "HR": "ChannelSourcePreview.module__subtextMuted___NElTUm",
  "G4": "ChannelSourcePreview.module__subtextPrimary___NElTUm",
  "XW": "ChannelSourcePreview.module__subtextBreadcrumb___NElTUm",
  "$T": "ChannelSourcePreview.module__subtextChevron___NElTUm",
  "my": "ChannelSourcePreview.module__avatar___NElTUm",
  "YQ": "ChannelSourcePreview.module__fallbackIcon___NElTUm",
  "bo": "ChannelSourcePreview.module__focusRingTight___NElTUm",
};

module.exports = exports;
